import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconFill$1 = /*@__PURE__*/ proxyCustomElement(class WppIconFill extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-fill", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M2.2276 10.5113V14.5263C2.2276 15.6164 3.11125 16.5 4.20129 16.5H16.0434C17.1334 16.5 18.0171 15.6164 18.0171 14.5263V5.84211C18.0171 4.75207 17.1334 3.86842 16.0434 3.86842H8.98254L10.1668 5.05263H16.0434C16.4794 5.05263 16.8329 5.40609 16.8329 5.84211V14.5263C16.8329 14.9623 16.4794 15.3158 16.0434 15.3158H4.20129C3.76527 15.3158 3.41181 14.9623 3.41181 14.5263V11.6955L2.2276 10.5113ZM5.3855 2.09211C5.3855 1.76509 5.65059 1.5 5.9776 1.5C6.30461 1.5 6.56971 1.76509 6.56971 2.09211V3.09103C6.92549 3.12281 7.27255 3.27486 7.54488 3.54719L10.3361 6.3384C10.9527 6.95502 10.9527 7.95476 10.3361 8.57137L6.98664 11.9208C6.37003 12.5374 5.37029 12.5374 4.75367 11.9208L1.96246 9.12962C1.34585 8.513 1.34585 7.51326 1.96246 6.89665L5.31192 3.54719C5.33588 3.52323 5.36042 3.5002 5.3855 3.4781V2.09211ZM5.3855 5.64474V5.14834L3.10433 7.42951H9.61354C9.60762 7.3371 9.56935 7.24639 9.49873 7.17577L6.70752 4.38456C6.66703 4.34407 6.61994 4.31421 6.56971 4.29499V5.64474C6.56971 5.97175 6.30461 6.23684 5.9776 6.23684C5.65059 6.23684 5.3855 5.97175 5.3855 5.64474ZM3.12129 8.61372L5.59104 11.0835C5.74519 11.2376 5.99512 11.2376 6.14928 11.0835L8.61903 8.61372H3.12129ZM9.33287 11.2697C9.33287 10.8802 9.45453 10.5021 9.60272 10.1793C9.75325 9.85136 9.94853 9.54321 10.1348 9.28379C10.3222 9.02281 10.5083 8.80029 10.6471 8.64325C10.7146 8.56696 10.8377 8.43694 10.8835 8.38854L10.8879 8.38395C11.1191 8.15272 11.494 8.15272 11.7252 8.38395L11.966 8.64325C12.1048 8.80029 12.2909 9.02281 12.4783 9.28379C12.6646 9.54321 12.8599 9.85136 13.0104 10.1793C13.1586 10.5021 13.2802 10.8802 13.2802 11.2697C13.2802 12.3674 12.468 13.3421 11.3066 13.3421C10.1451 13.3421 9.33287 12.3674 9.33287 11.2697ZM11.0967 9.97443C10.9376 10.1961 10.7875 10.4369 10.679 10.6733C10.5682 10.9147 10.5171 11.1164 10.5171 11.2697C10.5171 11.8155 10.8968 12.1579 11.3066 12.1579C11.7163 12.1579 12.096 11.8155 12.096 11.2697C12.096 11.1164 12.045 10.9147 11.9341 10.6733C11.8256 10.4369 11.6755 10.1961 11.5164 9.97443C11.4455 9.87568 11.3743 9.78285 11.3066 9.69823C11.2388 9.78285 11.1676 9.87568 11.0967 9.97443Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-fill-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-fill", "wpp-icon-fill-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-fill-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-fill-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconFill$1);
      }
      break;
  } });
}

const WppIconFill = WppIconFill$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconFill, defineCustomElement };
